var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / WS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-WS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#E31F37",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#083B9A",
    mask: "url(#mask-2)",
    x: -1.33333333,
    y: -1.33333333,
    width: 16,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60947571,7.72385763 L7.33333333,8.66666667 L7.60947571,9.60947571 L6.66666667,9.33333333 L5.72385763,9.60947571 L6,8.66666667 L5.72385763,7.72385763 L6.66666667,8 L7.60947571,7.72385763 Z M8.33333333,6.66666667 C8.51742825,6.66666667 8.66666667,6.81590508 8.66666667,7 C8.66666667,7.18409492 8.51742825,7.33333333 8.33333333,7.33333333 C8.14923842,7.33333333 8,7.18409492 8,7 C8,6.81590508 8.14923842,6.66666667 8.33333333,6.66666667 Z M4.94280904,4.39052429 L4.66666667,5.33333333 L4.94280904,6.27614237 L4,6 L3.05719096,6.27614237 L3.33333333,5.33333333 L3.05719096,4.39052429 L4,4.66666667 L4.94280904,4.39052429 Z M10.942809,3.72385763 L10.6666667,4.66666667 L10.942809,5.60947571 L10,5.33333333 L9.05719096,5.60947571 L9.33333333,4.66666667 L9.05719096,3.72385763 L10,4 L10.942809,3.72385763 Z M7.60947571,1.05719096 L7.33333333,2 L7.60947571,2.94280904 L6.66666667,2.66666667 L5.72385763,2.94280904 L6,2 L5.72385763,1.05719096 L6.66666667,1.33333333 L7.60947571,1.05719096 Z",
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/WS.11d5470170bd43925b11975b62fe648b.svg";
export { ForwardRef as ReactComponent };